"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxVirtualizedTimeCollectionStore = void 0;
var HxCollectionChange_1 = require("./HxCollectionChange");
var HxTimeRangeHelpers_1 = require("./HxTimeRangeHelpers");
var HxVirtualizedTimeCollection_1 = __importDefault(require("./HxVirtualizedTimeCollection"));
var HxVirtualizedTimeCollectionStore = /** @class */ (function () {
    function HxVirtualizedTimeCollectionStore(objectStore, nativeInterop) {
        this.objectStore = objectStore;
        this.collections = new Map();
        this.nativeInterop = nativeInterop;
    }
    HxVirtualizedTimeCollectionStore.prototype.hasCollection = function (collectionId) {
        return this.collections.has(collectionId.getCompactIDString());
    };
    HxVirtualizedTimeCollectionStore.prototype.findCollection = function (collectionId, sessionId) {
        if (!sessionId) {
            return null;
        }
        var entry = this.collections.get(collectionId.getCompactIDString());
        return entry ? entry.instances.get(sessionId) : null;
    };
    HxVirtualizedTimeCollectionStore.prototype.ensureCollection = function (collectionId, timeRange, objectType, getItemTimeRange, sessionId, activeSet) {
        var entry = this.collections.get(collectionId.getCompactIDString());
        if (!entry) {
            entry = { getItemTimeRange: getItemTimeRange, instances: new Map() };
            this.collections.set(collectionId.getCompactIDString(), entry);
        }
        var instance = entry.instances.get(sessionId);
        if (!instance) {
            instance = new HxVirtualizedTimeCollection_1.default(collectionId, objectType, 0 /*storageSequenceNumber*/, activeSet);
            entry.instances.set(sessionId, instance);
        }
        // Copy so the timeRange can't change unintentionally
        instance.timeRange = { start: new Date(timeRange.start), end: new Date(timeRange.end) };
        return instance;
    };
    HxVirtualizedTimeCollectionStore.prototype.releaseCollection = function (collectionId, sessionId) {
        var _this = this;
        var entry = this.collections.get(collectionId);
        // Assert entry
        if (entry) {
            var instance = entry.instances.get(sessionId);
            if (instance) {
                // Release item references this instance was holding.
                instance.items.forEach(function (item) { return _this.objectStore.releaseObject(item.objectId.getCompactIDString(), sessionId); });
                entry.instances.delete(sessionId);
                // If we just released the last instance then deactivate the collection.
                if (entry.instances.size === 0) {
                    this.nativeInterop.deactivateObject(instance.objectId, instance.storageSequenceNumber);
                    this.collections.delete(collectionId);
                }
            }
        }
    };
    // Return value indicates if any collection changed
    HxVirtualizedTimeCollectionStore.prototype.onCollectionLoadedByTimeRange = function (collection, timeRangeLoaded, sessionId) {
        var _this = this;
        var entry = this.collections.get(collection.objectId.getCompactIDString());
        var instance = entry ? entry.instances.get(sessionId) : undefined;
        if (!instance || !HxTimeRangeHelpers_1.areEqualTimeRanges(instance.timeRange, timeRangeLoaded)) {
            // The client might have released the collection or loaded a different time range in a race with load.
            if (!instance) {
                this.nativeInterop.deactivateObject(collection.objectId, collection.storageSequenceNumber);
            }
            return false;
        }
        // Add references for items we are adding and removing references for items we are dropping.
        // Add before removing so we don't drop an item from the object store and deactivate it.
        var oldItems = instance.items;
        collection.items.forEach(function (item) {
            _this.objectStore.addRefObject(item.objectId.getCompactIDString(), sessionId);
            _this.objectStore.updateObject(item);
        });
        oldItems.forEach(function (item) { return _this.objectStore.releaseObject(item.objectId.getCompactIDString(), sessionId); });
        instance.items = collection.items;
        return true;
    };
    // Return values indicates whether any collection changed
    HxVirtualizedTimeCollectionStore.prototype.onCollectionChanged = function (update) {
        var e_1, _a;
        var entry = this.collections.get(update.collectionId.getCompactIDString());
        if (!entry) {
            return [];
        }
        var sessionIds = [];
        try {
            for (var _b = __values(entry.instances), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), sessionId = _d[0], instance = _d[1];
                if (update.storageSequenceNumber >= instance.storageSequenceNumber) {
                    if (this.onInstanceChanged(instance, sessionId, update, entry.getItemTimeRange)) {
                        sessionIds.push(sessionId);
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return sessionIds;
    };
    // Return values indicates whether collection changed
    HxVirtualizedTimeCollectionStore.prototype.onInstanceChanged = function (instance, sessionId, update, getItemTimeRange) {
        var _this = this;
        var foundChanges = false;
        var timeRange = instance.timeRange;
        // For shallow compare, use a new array rather than mutating the existing one.
        var newItems = __spread(instance.items);
        update.changes.forEach(function (change) {
            switch (change.type) {
                case HxCollectionChange_1.HxCollectionChangeType.ItemCreated:
                case HxCollectionChange_1.HxCollectionChangeType.ItemChanged:
                    var object_1 = change.object;
                    var indexToUpdate = newItems.findIndex(function (item) { return item.objectId.isEqual(object_1.objectId); });
                    if (HxTimeRangeHelpers_1.areOverlappingTimeRanges(timeRange, getItemTimeRange(object_1))) {
                        if (indexToUpdate !== -1) {
                            // Update existing item
                            newItems.splice(indexToUpdate, 1, object_1);
                        }
                        else {
                            // Insert item into collection
                            _this.objectStore.addRefObject(object_1.objectId.getCompactIDString(), sessionId);
                            newItems.push(object_1);
                        }
                        // Update this object in the object store too.
                        _this.objectStore.updateObject(object_1);
                        foundChanges = true;
                    }
                    else if (indexToUpdate !== -1) {
                        // Remove this item from this instance since it's no longer in range
                        _this.objectStore.releaseObject(object_1.objectId.getCompactIDString(), sessionId);
                        newItems.splice(indexToUpdate, 1);
                    }
                    break;
                case HxCollectionChange_1.HxCollectionChangeType.ItemRemoved:
                    var indexToRemove = newItems.findIndex(function (item) { return item.objectId.isEqual(change.objectId); });
                    if (indexToRemove !== -1) {
                        _this.objectStore.releaseObject(change.objectId.getCompactIDString(), sessionId);
                        newItems.splice(indexToRemove, 1);
                        foundChanges = true;
                    }
                    break;
            }
        });
        if (foundChanges) {
            instance.items = newItems;
        }
        return foundChanges;
    };
    return HxVirtualizedTimeCollectionStore;
}());
exports.HxVirtualizedTimeCollectionStore = HxVirtualizedTimeCollectionStore;
exports.default = HxVirtualizedTimeCollectionStore;
